import { InjectionToken } from '@angular/core';
import { BuupassAuthConfig } from '../types/auth-config';

export const BUUPASS_AUTH_CONFIG = new InjectionToken<BuupassAuthConfig>('BUUPASS_AUTH_CONFIG');
